module.exports = __webpack_public_path__ + "static/media/KW12_AS2.8197bca8.png";